import React from "react"
import Page from "../components/page";
import { Link } from "gatsby";
import RatingsGrid from "../components/ratingsgrid";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Seasons from "../../data/seasons.json";

export default class HistoricalPage extends React.Component {
    state = {
        season_code: "2425"
    }
    componentDidMount() {
      this.selectSeason("2425");
    }
    isSeasonSelected = (season_code) => this.state.season_code === season_code;
    
    yearButton = (season_code, description) => <Button variant="text" size="large" disabled={this.isSeasonSelected(season_code)} onClick={(e)=>this.selectSeason(season_code)}>{description}</Button>;
    selectedSeasonName(){
      let season_code = this.state.season_code;
      let season=Seasons.find(s=>s['code']===season_code);
      return season['name'];
    }
    


    selectSeason = (season_code) => this.setState({season_code:season_code});
    
    render() {
      const pageTitle="Historical College Basketball Ratings by Season | CBB Ratings";
      const seoDescription="Historical NCAA men's college basketball ratings by season (back to 2015), generated with the same model so teams can be compared across years.";
      const pageHeading="Historical College Basketball Ratings";
      const subHeading="Season-by-season ratings dating back to 2015";
    return (
      <Page
        location={this.props.location.href}
        pageTitle={pageTitle}
        seoDescription={seoDescription}
        pageHeading={pageHeading}
        subHeading={subHeading}
      >
            <p>
              Historical ratings are available for every NCAA men's college basketball season dating back to 2015, all generated using the same <Link to="/methodology">rating methodology</Link>.
              <br/>
              This allows for consistent comparisons across seasons, including notable anomalies such as the reduced home-court advantage during the{" "}
              <a
                href="#season"
                onClick={(e) => {
                  e.preventDefault();
                  this.selectSeason("2021");
                }}
              >
                COVID-affected year
              </a>
              .
            </p> 
    <Table>
        <TableBody>
        <TableRow>
            {Seasons.map(s=><TableCell key={s['code']}>{this.yearButton(s['code'], s['name'])}</TableCell>)}
        </TableRow>
        </TableBody>
    </Table>

      <h2 id="season">{this.selectedSeasonName()}</h2>
      <RatingsGrid season={this.state.season_code} />
    </Page>
    );
  }
};
